export const DATA = {
  "Skill level": "Beginner",
  "Time to complete": "Approx. 36 hours",
  Certificate: "Included",
  Prerequesties: "Html, Css, Js and Programming Logic",
  description: " Build Dynamic, Scalable Web Apps from Scratch",
  about:
    " Learn to build modern, responsive, and scalable web applications by mastering React for frontend and Express.js for backend development. Gain hands-on in experience creating REST APIs, integrating databases, and deploying full-stack applications.",
  skills: [
    "Responsive UI/UX Design",
    "RESTful API Development",
    "Database Design & Management",
    "Git & Version Control",
  ],
  reviews: {
    1: {
      name: "Kaden Bishop",
      review:
        "This Full Stack course was amazing! I finally understand both frontend and backend workflows. The instructor explained every concept with clarity and practical examples.",
    },
    2: {
      name: "Leila Navarro",
      review:
        "A very well-structured course. I loved how the modules moved from HTML and CSS to APIs and databases. Everything felt connected and easy to follow.",
    },
    3: {
      name: "Oskar Lindholm",
      review:
        "Great hands-on experience! Building real projects helped me understand how full stack applications work. Highly recommended for beginners.",
    },
    4: {
      name: "Tara McAllister",
      review:
        "The best part about this course is how smoothly it transitions from frontend to backend. I now feel confident creating complete web applications.",
    },
    5: {
      name: "Imran Zaheer",
      review:
        "Very engaging course content. The lessons on REST APIs, authentication, and database integration were especially helpful.",
    },
    6: {
      name: "Bethany Reeves",
      review:
        "The course covers everything you need to start building full stack apps. The projects were fun and helped reinforce every topic.",
    },
    7: {
      name: "Elias Søndergaard",
      review:
        "I loved learning about both React and backend frameworks in a single course. The explanations were clear and beginner-friendly.",
    },
    8: {
      name: "Nuria Delgado",
      review:
        "Amazing course! I learned how to design interfaces, build APIs, connect databases, and deploy applications. Truly comprehensive.",
    },
    9: {
      name: "Jordan Atkins",
      review:
        "The instructor broke down complex topics like routing and state management beautifully. I can now build dynamic websites confidently.",
    },
    10: {
      name: "Milena Trifunovic",
      review:
        "This course introduced me to modern web development in such an easy way. I appreciated the real-world examples and assignments.",
    },
    11: {
      name: "Rylan Cortez",
      review:
        "A fantastic learning experience. The step-by-step approach to building full stack solutions made everything click.",
    },
    12: {
      name: "Mireille Diarra",
      review:
        "I loved how this course explained both the client and server sides. Deploying my first full stack project felt amazing.",
    },
    13: {
      name: "Callan Hughes",
      review:
        "The practical tasks were my favorite. They helped me understand how frontend components interact with backend logic.",
    },
    14: {
      name: "Aya Matsumoto",
      review:
        "Very thorough and easy to understand. The course taught me everything from building REST APIs to working with databases.",
    },
    15: {
      name: "Cyrus Whitman",
      review:
        "This course gave me the foundation I needed. I learned how to create clean user interfaces and connect them seamlessly to backend services.",
    },
    16: {
      name: "Samira Nwosu",
      review:
        "Great explanations and real examples. I now understand MVC architecture, API routes, and data modeling clearly.",
    },
    17: {
      name: "Hector Molina",
      review:
        "I enjoyed the full stack project at the end. Building a complete application from scratch taught me more than any tutorial ever has.",
    },
    18: {
      name: "Noelle Farrington",
      review:
        "This course helped me understand the full workflow of web apps—from UI design to server responses. Super helpful!",
    },
    19: {
      name: "Zayden Patel",
      review:
        "The course was both challenging and rewarding. The backend modules, especially authentication and routing, were explained very well.",
    },
    20: {
      name: "Valeria Rojas",
      review:
        "I can finally create functional apps with front-end frameworks and backend APIs. The lessons were clear and organized.",
    },
    21: {
      name: "Eduardo Ferreira",
      review:
        "The best full stack course I’ve taken. Everything is broken down into simple steps, making it easy to follow and practice along.",
    },
    22: {
      name: "Sunny McGregor",
      review:
        "I enjoyed every bit of this course. Learning databases, backend logic, and deployment all in one place was extremely helpful.",
    },
    23: {
      name: "Kiana Ali",
      review:
        "Such a practical course! I learned how to build responsive interfaces and connect them to powerful backend systems.",
    },
    24: {
      name: "Jonah Svensson",
      review:
        "The real-world examples made the learning process smooth and enjoyable. I finally understand how full stack development works.",
    },
    25: {
      name: "Mira Gonzalez",
      review:
        "Excellent course for aspiring developers. The projects, explanations, and structure made learning full stack development simple and fun.",
    },
  },
  modules: {
    "React Front-End Foundations": [
      "node.js basics, npm installation, and environment setup.",
      "Review of HTML5, CSS3, and JavaScript ES6 concepts.",
      "React fundamentals: components, JSX, props, and state.",
      "Using React Hooks (useState, useEffect) and Context API.",
      "Routing with React Router v6.",
      "Working with REST APIs.",
      "Building Responsive UI with Tailwind/Material UI.",
    ],
    "Backend with Express.js": [
      "Setting up REST APIs with Express.",
      "Middleware, routing, and request/response lifecycle.",
      "Handling forms, JSON, and CORS.",
      "Authentication and Authorization with JWT.",
      "Error handling & best practices.",
      "Understand asynchronous programming.",
    ],
    "Database Integration": [
      "CRUD Ops with MongoDB/MySQL.",
      "Mongoose ORM / SQL Basics.",
      "Data Validation & Schema Design.",
      "Handling File Uploads.",
      "Caching and Optimization.",
    ],
    "Full Stack Integration": [
      "Connecting React front-end with Express backend via APIs.",
      "Conditional rendering for user roles.",
      "Consistent frontend & backend responses.",
      "Deploy to Render, Vercel, or AWS.",
    ],
    "Real-World Impact & Capstone Journey": [
      "Build a Complete Full-Stack Applications like Task Manager, E-Commerce Platform, Event Booking Platform, Social Media App.",
      "End-to-End Implementation & Deployment.",
      "Portfolio Showcase & Presentation.",
    ],
  },
};
